export default function ErrorPage({ status }) {
    return (
        <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Oeps, er ging iets mis.</h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            Maak je geen zorgen, wij hebben het al opgemerkt en zullen het zo snel mogelijk oplossen. Je hoeft niets te doen, de gegevens uit het contactformulier hebben wij al ontvangen.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="/"
              className="rounded-md bg-we-are-purple px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm"
            >
              Ga naar de homepagina
            </a>
          </div>
        </div>
      </main>
    )
  }